import CRUD from './genericCRUD'

const route = 'farm_supplier_codes'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function farmSupplierCodes(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} code
		 * @param {number} farmId
		 * @param {number} phaseId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, code, farmId, phaseId, config) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const codeParam = code ? `code=${code}&` : ''
			const farmParam = farmId ? `farmId=${farmId}&` : ''
			const phaseParam = phaseId ? `phaseId=${phaseId}&` : ''

			return instance.get(
				`${route}?${params}${codeParam}${farmParam}${phaseParam}`,
				config
			)
		}
	}
}
